(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crew-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('crew-card')) {
    customElements.define('crew-card', class extends HTMLElement {
      connectedCallback() {
        this.img = this.querySelector('.crew-card__img');
        this.frame = this.querySelector('.crew-card__frame');
        this.dots = Array.from(this.querySelectorAll('.crew-card__dot'));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.select(dot)));
        this.addEventListener('pointerenter', () => this.prefetch(), { once: true });
      }
      select(dot) {
        if (this.img && dot.dataset.image) {
          this.img.removeAttribute('srcset');
          this.img.removeAttribute('sizes');
          this.img.src = dot.dataset.image;
        }
        if (this.frame && dot.dataset.tint) this.frame.style.background = dot.dataset.tint;
        this.dots.forEach((d) => d.classList.toggle('is-active', d === dot));
      }
      prefetch() {
        this.dots.forEach((d) => { if (d.dataset.image) { const i = new Image(); i.src = d.dataset.image; } });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
